/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React from "react";
import "./styles/css/basic-info.css";
import { Grid } from "semantic-ui-react";
import {isWhiteLabel} from "../util"

const white = {
  color: "white",
  marginTop: "25px"
};

const none = {
  display: "none"
};

const Footer = (props) => {
  const selectStyle = props.background === "grayBackground" ? none : white;

  return (
    <div className={"footer-wrapper"} style={selectStyle}>
      <p>
        <span className="companyName">
          <a 
            href="https://klearnow.ai/" 
            target="_blank" 
            rel="noopener noreferrer"
            title="Visit KlearNow.AI"
            style={selectStyle}
          >
            <strong>KlearNow.AI</strong>
          </a>
        </span>
        &nbsp; &nbsp;| &nbsp; &nbsp;
        <a style={selectStyle} href="/view-terms">
          Terms
        </a>
        &nbsp; &nbsp; | &nbsp; &nbsp;
        <a style={selectStyle} href="/privacy">
          Privacy
        </a>
        &nbsp; &nbsp;
      </p>
    </div>
  );
};

export default Footer;
